import { Record } from 'immutable';
import { getKnowledgeBaseDetailsEmptyState } from '../data/KnowledgeBaseDetails';
const KnowledgeBaseRecord = Record(getKnowledgeBaseDetailsEmptyState());
export default KnowledgeBaseRecord;